import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { CustodyCase } from '../../types/case';
import { timeline } from '../../utils/caseStatus';
import { fmtDateTime } from '../../utils/bn';
export function VehicleTimeline({
  c
}: {
  c: CustodyCase;
}) {
  const items = timeline(c);
  const firstPending = items.findIndex(i => !i.entry);
  return <ol className="relative" data-id="element-395" data-mp="3e9w4betjnyhv">
      {items.map((it, idx) => {
      const done = !!it.entry;
      const current = idx === firstPending;
      return <li key={it.label} className="relative flex gap-3 pb-5 last:pb-0" data-id="element-396" data-mp="3o94xw6khzb3p" data-mpi={idx}>
            {idx < items.length - 1 && <span className={`absolute left-[13px] top-7 bottom-0 w-0.5 ${done ? 'bg-success' : 'bg-line'}`} aria-hidden data-id="element-397" data-mp="3t1eqjuczyp9o" />}
            <span className={`relative z-10 mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 ${done ? 'bg-success border-success text-white' : current ? 'bg-white border-navy' : 'bg-white border-line'}`} data-id="element-398" data-mp="5w74yjm4hij1">
              {done ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-399" data-mp="2uttigeenrp4s" /> : current ? <span className="h-2 w-2 rounded-full bg-navy" data-id="element-400" data-mp="2us8oapw9a87g" /> : null}
            </span>
            <div className="min-w-0" data-id="element-401" data-mp="2qshzgrqai25k">
              <p className={`text-sm font-semibold ${done ? 'text-ink' : current ? 'text-navy' : 'text-ink-soft'}`} data-id="element-402" data-mp="2lsvf7yc1nln9">{it.label}</p>
              {it.entry ? <p className="text-xs text-ink-muted mt-0.5" data-id="element-403" data-mp="3iimfke70o30z">
                  {fmtDateTime(it.entry.at)} · {it.entry.actor}
                </p> : <p className="text-xs text-ink-soft mt-0.5" data-id="element-404" data-mp="39q10p96iaghf">{current ? 'চলমান' : 'অপেক্ষমাণ'} · {it.office}</p>}
            </div>
          </li>;
    })}
    </ol>;
}